






import axios from 'axios';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ProductList from '../Category/ProductList.vue';
import { Product, ProductListItem } from '@/models/Product';

@Component({
    components: {
        ProductList
    }
})
export default class ProductListBlock extends Vue {
    protected products: ProductListItem[];
    protected countClass: string;
    protected productNameTag: string;
    constructor() {
        super();
        this.products = JSON.parse(this.$attrs['data-products']);
        this.countClass = this.$attrs['data-count-class'];
        this.productNameTag = this.$attrs['data-product-name-tag'];        
        this.$attrs['data-products'] = '';
        this.$attrs['data-count-class'] = '';
    }
}
